<template src="./list.html"></template>

<script>

import SchoolService from 'Services/SchoolService';

export default {
  data() {
    return {
      schoolJPs: [],
      schoolVNs: [],
      schoolOthers: [],
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    convertHTML(value) {
      if (value.length < 100) {
        return `${value.replace(/(<([^>]+)>)/g, '')}`;
      }
      return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 100)}...`;
    },
    ready(event) {
      this.player = event.target;
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const paramsJP = {
        type_contact: 1,
        take: 8,
        i18n: this.i18n,
      };
      const paramsVN = {
        type_contact: 2,
        take: 8,
        i18n: this.i18n,
      };
      const paramsOther = {
        type_contact: 3,
        take: 8,
        i18n: this.i18n,
      };
      SchoolService.listTop(paramsJP)
        .then((response) => {
          this.schoolJPs = response.data;
        })
        .catch(() => {});
      SchoolService.listTop(paramsVN)
        .then((response) => {
          this.schoolVNs = response.data;
        })
        .catch(() => {});
      SchoolService.listTop(paramsOther)
        .then((response) => {
          this.schoolOthers = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
};
li {
    margin-bottom: -70px;
}
</style>
